module.exports = __webpack_public_path__ + "static/media/forthScreen@3x.c9b81d70.png";